import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace CspOrder {
    /**
    * 获取发布订单列表(已自测)
    */
    export var getCspOrderList = (query: any): Promise<any> => {
        return Get(`/csp/CspOrder/getCspOrderList?${qs.stringify(query)}`, {});
    };
    /**
    * 获取发布订单详情(已自测)
    */
    export var getCspOrder = (id: string): Promise<any> => {
        return Get(`/csp/CspOrder/getCspOrder/${id}`, {});
    };
    /**
    * 获取订单详情 (复制新增时调用)
    */
    export var getCspOrderDetail = (id): Promise<any> => {
        return Get(`/csp/CspOrder/getCspOrderDetail/${id}`, {});
    };
    /**
     * 添加发布订单(已自测)
     */
    export var addCspOrder = (body: any): Promise<any> => {
        return Post(`/csp/CspOrder/addCspOrder`, body);
    };
    /**
     * 编辑订单信息(已自测)
     */
    export var UpdateCspOrder = (body: any): Promise<any> => {
        return Post(`/csp/CspOrder/UpdateCspOrder`, body);
    };
    /**
     * 终结发布订单(已自测)
     */
    export var editCspOrder = (id: any): Promise<any> => {
        return Put(`/csp/CspOrder/editCspOrder/${id}`, {});
    };

    /**
     * 删除发布订单(已自测)
     */
    export var deleteCspOrder = (id: string): Promise<any> => {
        return Delete(`/csp/CspOrder/deleteCspOrder/${id}`, {});
    };

    /**
    * 导入
    */
    export var uploadexcel = (body: any): Promise<any> => {
        return Post(`/csp/CspOrder/uploadexcel`, body);
    };
    /**
    * 导出
    */
    export var GetCspOrderListExport = (query: any): Promise<any> => {
        return Get(`/csp/CspOrder/GetCspOrderListExport?${qs.stringify(query)}`, {});
    };

    /**
    * 下载模板
    */
    export var GetTemplate = (query: any): Promise<any> => {
        return Get(`/csp/ExportTemplate/GetTemplate?${qs.stringify(query)}`, {});
    };

    /**
 * 导入上传
 */
    export var AddExcelData = (body: any): Promise<any> => {
        return Post(`/csp/CspOrder/AddExcelData`, body);
    };

}
